/**
 * Accepts an int representing minutes and will convert it into a string
 * representing the amount of hours and minutes
 *
 * e.g. minutes = 130, returns `2 hours 10 minutes`
 *
 * @param {Number} minutes
 * @param {Boolean} abbreviated will shorten the quantifier (e.g. minutes to min)
 * @returns {String}
 */
export const minutesToHoursMinsString = (minutes, abbreviated = false) => {
  if (typeof minutes !== 'number')
    throw Error('Invalid data type for minutes (Expected Number)')

  const minutesSingular = abbreviated ? 'min' : 'minute'
  const minutesPlural = abbreviated ? 'min' : 'minutes'
  const hoursSingular = abbreviated ? 'hr' : 'hour'
  const hoursPlural = abbreviated ? 'hr' : 'hours'

  let hours = 0
  let remainingMinutes = 0
  let minutesString = `0 ${minutesPlural}`
  let hourString = ''

  hours = Math.floor(minutes / 60)
  remainingMinutes = minutes % 60
  minutesString =
    minutes === 0
      ? `${remainingMinutes} ${minutesPlural}`
      : remainingMinutes >= 2
      ? `${remainingMinutes} ${minutesPlural}`
      : remainingMinutes === 0
      ? ''
      : `${remainingMinutes} ${minutesSingular}`

  hourString =
    hours > 1
      ? `${hours} ${hoursPlural}`
      : hours < 1
      ? ''
      : `${hours} ${hoursSingular}`

  return `${
    hourString ? `${hourString}${minutesString ? ' ' : ''}` : ''
  }${minutesString}`
}
